import { I18n } from 'react-redux-i18n';
const billingPageSearchFields = (searchFieldValues, companyList, buildingList, floorList) => {
    if(companyList.length > 1){
        return {
            rows: [
             
                {
                    hasTopBreak: false,
                    hasBottomBreak: false,
                    fields: [
                    
                        {
                            id: "company",
                            label: I18n.t('billingPage.list.company'),
                            type: "dropdown",
                            value: searchFieldValues?.company?.value,
                            data: companyList,
                            validator: () => { }
                        },
                        {
                            id: "building",
                            label: I18n.t('billingPage.list.building'),
                            type: "dropdown",
                            value: searchFieldValues?.building?.value,
                            data: buildingList,
                            validator: () => { }
                        },
                      {
                            id: "floor",
                            label: I18n.t('billingPage.list.floor'),
                            type: "dropdown",
                            value: searchFieldValues?.floor?.value,
                            data: floorList,
                            validator: () => { }
                        } 
                    ]
                }
            ]
        }
    }else{
        return {
            rows: [
             
                {
                    hasTopBreak: false,
                    hasBottomBreak: false,
                    fields: [
                   
                        {
                            id: "building",
                            label: I18n.t('billingPage.list.building'),
                            type: "dropdown",
                            value: searchFieldValues?.building?.value,
                            data: buildingList,
                            validator: () => { }
                        },
                      {
                            id: "floor",
                            label: I18n.t('billingPage.list.floor'),
                            type: "dropdown",
                            value: searchFieldValues?.floor?.value,
                            data: floorList,
                            validator: () => { }
                        } 
                    ]
                }
            ]
        }
    }
  
};

export {
    billingPageSearchFields
}